<template>
    <a :name="project.name">
        <div id="module">
            <div id="information">
                <div id="title">
                    <h1>{{ project.name }}</h1>
                    <h5> {{ project.date }} </h5>
                </div>
                <div id="icons">
                    <GithubIcon v-if="'github' in project.links" :link="project.links['github']" :id="id" :darkMode="true"/>
                    <FlickrIcon v-if="'flickr' in project.links" :link="project.links['flickr']" :darkMode="true"/>
                    <EtsyIcon v-if="'etsy' in project.links" :link="project.links['etsy']" :darkMode="true"/>
                </div>
                <div id="description">
                    <h4 v-html="project.description"></h4>
                </div>
            </div>
            <div id="gallery" @click.stop="displayModal">
                <Slideshow 
                    style="position: relative; width: 100%;background-color: #ECECEC"
                    :images="this.images"
                    :collageSizeMax="3"
                    :slidesInterval="6000 + (Math.random()*2000)"
                    :showNoImagesMsg="true"
                    noImagesMsg="No Images"
                    :showLoadingMsg="true"
                    loadingMsg="Loading..."
                    height="100%"
                    :key="test"
                />
            </div>
            <!-- https://tympanus.net/codrops/2013/06/25/nifty-modal-window-effects/ for later effects work -->
            <div class="modal modal-effect" :id="'modal' + this.id" :class="{show:showModal}">
                <div class="slideshow content" v-click-outside.stop="closeModal">
                    <span class="close" @click="closeModal">&times;</span>
                    <carousel :key="test" class="carousel" style="display: flex; justify-content: center;" :data="data" :autoplay="false"></carousel>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import Slideshow from 'vue-collage-slideshow'
import GithubIcon from './icons/Github.vue'
import FlickrIcon from './icons/Flickr.vue'
import EtsyIcon from './icons/Etsy.vue'
import Carousel from '@chenfengyuan/vue-carousel'
// https://fengyuanchen.github.io/vue-carousel/#

export default {
    props: {
        reverse: Boolean,
        project: Object,
        id: Number
    },
    components: {
        Slideshow,
        Carousel,
        GithubIcon,
        FlickrIcon,
        EtsyIcon,
    },
    data() {
        return {
            link1: "https://www.github.com",
            link2: "https://www.flickr.com",
            link3: "https://www.etsy.com",
            link4: "https://www.linkedin.com/in/DylanCauwels",
            data: [],
            url: "url(" + require('@/assets/backgrounds/work.jpeg') + ")",
            images: [],
            test: 0,
            showModal: false
        }
    },
    mounted() {
        this.project.images.forEach(element => {
            var path = require('@/assets/projects' + this.project.slug + '/' + element);
            this.images.push({image: path});
            this.data.push('<div class="slide"><img src="' + path +  '" alt="" /> </div>')
        })
        this.project.videos.forEach(element => {
            this.data.push('<div class="slide"><video controls><source src="' + require('@/assets/projects' + this.project.slug + '/' + element) + '" type="video/mp4"></video></div>');
        })
        this.test += 1;
    },
    methods: {
        displayModal: function () {
            this.showModal = true;
            document.documentElement.style.overflow = 'hidden';
        },
        closeModal: function() {
            this.showModal = false;
            document.documentElement.style.overflow = 'auto';
        }
    }
}
</script>

<style scoped>
    .carousel >>> img, .carousel >>> video {
        max-height: 100%;
        max-width: 100%;
        /* width: auto; */
        display: flex;
        margin-left: auto;
        margin-right: auto;
        margin-top: auto;
        outline: none;
    }
    .carousel >>> .slide {
        align-items: center;
        background-color: #414141;
        color: #999;
        display: flex;
        font-size: 1.5rem;
        justify-content: center;
        min-height: 10rem;
        height: 80vh;
        width: 80vw;
    }
</style>

<style scoped>
    .modal-effect { /*md-effect-1*/ }
    .content { /*md-content*/ }
    .modal-effect .content {
        -webkit-transform: scale(0.7);
        -ms-transform: scale(0.7);
        transform: scale(0.7);
        opacity: 0;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }
    .show.modal-effect .content {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
    #modal { /*modal-1*/
        display: block;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,0.75); 
        margin: 0px;
    }
    .modal { /*md-modal*/ 
        visibility: hidden;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.6);
        overflow-y: hidden;
    }
    .show {
        visibility: visible;
    }
    .slideshow {
        position: relative;
        display: flex;
        justify-content: center;
        background-color: #414141;
        margin: auto;
        padding: 20px;
        width: 90vw;
        height: 90vh;
    }
    .close {
        color: #aaaaaa;
        float: right;
        font-size: 2rem;
        font-weight: bold;
        position: absolute;
        right: 5px;
        top: 0px;
        border-radius: 50%;
        padding-left: 7px;
        padding-right: 7px;
        padding-bottom: 2px;
        margin-top: 5px;
        z-index: 1;
        transition: all .2s linear;
    }
    .close:hover,
    .close:focus {
        color: #ec8c13;
        text-decoration: none;
        cursor: pointer;
        background-color: #6f6f6f;
    }
    #module {
        padding: 40px;
        padding-top: 0px;
        padding-bottom: 150px;
        flex-direction: row;
        background-color: #ECECEC;
        justify-content: space-between;
        min-height: 70vh;
    }
    /* padding pushed down to children so they're spaced when they switch to column mode */
    #module > div {
        padding-top: 40px;
    }
    #information {
        flex-direction: column;
        width: 35%;
    }
    #title {
        flex-direction: row;
        align-items: baseline;
    }
    #title h1 {
        margin: 0px;
        font-weight: bolder;
        color: #1D1D1D;
        font-size: 3.5rem;
    }
    #title h5 {
        padding-left: 10px;
        font-style: italic;
        font-weight: 300;
        font-size: 1.5rem;
        color: #797979;
    }
    #icons {
        flex-direction: row;
        padding-bottom: 20px;
        align-items: flex-end;
        flex-wrap: wrap;
    }
    #description h4 {
        font-size: 22px;
    }
    @media (max-width: 1100px) {
        #information {
            width: 100%;
        }
        #gallery {
            width: 100% !important;
        }
    }
    @media (min-width: 1700px) {
        #module {
            justify-content: space-around;
        }
    }
    #gallery {
        width: 55%;
        min-height: 400px;
    }
    #gallery:hover {
        cursor: pointer;
    }
    div {
        display: flex;
        flex-wrap: wrap;
    }
</style>